import dayjs from "dayjs";
import { PlantingDTO, PlantingStatus } from "seedgreen-shared/dtos/PlantingDTO";
import { DateString } from "seedgreen-shared/types/datestring.types";

export function plantingStatusBackgroundClass(status?: PlantingDTO["status"]) {
	switch (status) {
		case PlantingStatus.Upcoming:
			return "bg-yellow-500";
		case PlantingStatus.Established:
			return "bg-green-600";
		case PlantingStatus.Active:
			return "bg-blue-500";
		case PlantingStatus.Harvested:
			return "bg-yellow-900";
	}
	return "bg-gray-500";
}

export function plantingStatusTextClass(status?: PlantingDTO["status"]) {
	switch (status) {
		case PlantingStatus.Upcoming:
			return "!text-white";
		case PlantingStatus.Established:
			return "!text-white";
		case PlantingStatus.Active:
			return "!text-white";
		case PlantingStatus.Harvested:
			return "!text-white";
	}
	return "text-black";
}

export function getDefaultPlantingQueryRange() {
	return {
		start: dayjs().subtract(1, "month").format("YYYY-MM-DD") as DateString,
		end: dayjs().add(1, "month").format("YYYY-MM-DD") as DateString,
	};
}
